// lib/auth-roles.ts
// The only role allowed to view all PICs + the "Tất cả PIC (ALL)" option.
// Lives in a plain module (no JSX / no "use client") so server components,
// route handlers, and tests can import it without pulling client code.
export const ADMIN_ROLE = "admin";

// Better Auth stores role as a comma-separated multi-role string ("admin,sale").
// Membership check — exact-match === missed compound roles (workspace hit this bug:
// admin accounts silently lost every admin surface).
export function hasAdminRole(role: string | null | undefined): boolean {
  if (!ADMIN_ROLE) return false; // fail closed if the constant is ever emptied
  return (role || "").split(",").map((r) => r.trim().toLowerCase()).includes(ADMIN_ROLE.toLowerCase());
}
